
















































import { Component, Vue } from "vue-property-decorator";
import { pics } from "@/config/host.config";

import StandartDraggableAlert from "@/components/app/shared/alerts/standart-draggable-alert.vue";
import draggable from "vuedraggable";

import InstructionsCard from "@/components/instructions/instructions-card.vue";
import InstructionsEditModal from "@/components/instructions/instructions-edit-modal.vue";
import InstructionsFilesModal from "@/components/instructions/instructions-files-modal.vue";

import type { ISection } from "@/@types/instructions/section";

@Component({
  components: {
    InstructionsCard,
    InstructionsEditModal,
    InstructionsFilesModal,
    draggable,
    StAlert: StandartDraggableAlert,
  },
})
class InstructionsPage extends Vue {
  enabled = true;
  dragging = false;

  sections: ISection[] = [];
  active_id = "";
  edit_item: ISection | null = null;

  get sections_item(): ISection | null {
    const item = this.sections.find((el) => el._id === this.active_id);
    return item ? item : null;
  }

  mounted(): void {
    this.getSectionsList();
  }

  openAdd(): void {
    this.edit_item = null;
    this.$nextTick(() => this.$bvModal.show("instructions-edit"));
  }

  mustEditCard(id: string): void {
    const item = this.sections.find((el) => el._id === id);
    this.edit_item = item ? item : null;
    this.$nextTick(() => this.$bvModal.show("instructions-edit"));
  }

  mustFiles(id: string): void {
    this.active_id = id;
    this.$nextTick(() => this.$bvModal.show("instructions-files"));
  }

  onDragEnd(): void {
    this.dragging = false;
    this.saveSorts();
  }

  saveSorts(): void {
    for (let i = 0; i < this.sections.length; i++) {
      const id = this.sections[i]._id;
      if (!id) continue;
      try {
        this.$axios.put(pics.sections + "/" + id, { sort_order: i + 1 });
      } catch (e) {
        console.error(e);
      }
    }
  }

  async getSectionsList(): Promise<void> {
    try {
      const res = await this.$axios.get(pics.sections);
      if (res.status === 200) this.sections = res.data;
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  async saveSection(data: Partial<ISection>): Promise<void> {
    if (!data) return;
    try {
      if (this.edit_item && this.edit_item._id) {
        await this.updateSectionById(this.edit_item._id, data);
      } else {
        const res = await this.$axios.post(pics.sections, data);
        if (res.status === 200) this.getSectionsList();
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  async confirmDeleteSection(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("Instructions.confirmDelete")),
        {
          title: String(this.$i18n.t("main.confirms.delete")),
          okVariant: "danger",
        }
      );
      if (result === true) await this.deleteSection(id);
    } catch {
      this.onError();
    }
  }

  async deleteSection(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await this.$axios.delete(pics.sections, {
        params: { id },
      });
      if (res.status === 200) {
        const i = this.sections.findIndex((el) => el._id === id);
        if (i >= 0) this.sections.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  async updateSectionById(id: string, data: Partial<ISection>): Promise<void> {
    if (!id) return;
    const uri = pics.sections + "/" + id;
    try {
      const putres = await this.$axios.put(uri, data);
      if (putres.status === 200) {
        const i = this.sections.findIndex((el) => el._id === id);
        if (i < 0) this.getSectionsList();
        else this.$set(this.sections, i, putres.data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }
}
export default InstructionsPage;
